var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }